import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { fetchPostTruelayerAuthorizationUrl } from '@iwoca/lapi-client/edge';
import { Icon } from '@iwoca/orion';
import { Trans } from '@lingui/react/macro';

import styles from './TrueLayer.module.css';
import TrueLayerModal from './TrueLayerModal/TrueLayerModal';
import { useContextStateKey } from '../../../hooks/useContextStateKey';
import { useSplitTest } from '../../../hooks/useSplitTest';
import {
  getCookie,
  useGetContext,
} from '../../../lendingApi/lendingApiQueries';
import { getAmplitudeDefaultEventProperties } from '../../../utils/amplitudeEvents';
import logger from '../../../utils/logger';
import { Button } from '../../Button/Button';

type TProps = {
  disabled?: boolean;
};

const LinkTrueLayer = ({ disabled }: TProps) => {
  const stateKey = useContextStateKey();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { hasTrueLayerConsentFlowEnabled } = useSplitTest();
  const { context } = useGetContext();

  const trueLayerModalCookie = getCookie('new_true_layer_modal');

  const handleClick = async () => {
    if (!stateKey) return;

    tracking.ampli.openBankingConnectStarted(
      getAmplitudeDefaultEventProperties(),
    );

    if (hasTrueLayerConsentFlowEnabled || trueLayerModalCookie) {
      return setIsModalOpen(true);
    }

    try {
      setIsLoading(true);
      const response = await fetchPostTruelayerAuthorizationUrl({
        stateKey,
      });

      if (response.data?.authorization_url) {
        window.location.href = response.data?.authorization_url;
      }
    } catch (error: unknown) {
      if (error instanceof Error) {
        logger.error('Failed to post true layer auth URL', {
          error: error.message,
        });
      }
    }
  };

  const handleTrueLayerClose = () => {
    tracking.ampli.trueLayerModalClosed();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        className={styles.button}
        variant="secondary"
        onClick={handleClick}
        loading={isLoading}
        disabled={disabled || !stateKey}
      >
        <Trans>Link bank account</Trans>
        <Icon icon="link" />
      </Button>
      {(hasTrueLayerConsentFlowEnabled || trueLayerModalCookie) && (
        <TrueLayerModal
          isOpen={isModalOpen}
          handleClose={handleTrueLayerClose}
          // @ts-expect-error because dumb context schema
          bankList={context.open_banking.truelayer_banks}
        />
      )}
    </>
  );
};

export default LinkTrueLayer;
